import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import AtIconWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {EventType} from "../../../constants/AppsmithActionConstants/ActionConstants";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TIcon extends TaroWidget<AtIconWidgetProps, WidgetState> {
  constructor(props: AtIconWidgetProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("AtIconWidget");
  }



  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.label }}`
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
    };
  }
  onClick(){
    if(this.props.isDisabled!=true){
      super.executeAction({
        triggerPropertyName: "onClick",
        dynamicString: this.props.onClick,
        event: {
          type: EventType.ON_CLICK
        },
      });
    }
  }
  getPageView() {
    return (
      <AtIconWidget {...this.props} onClick={this.onClick} />
    );
  }
  static getWidgetType(): WidgetType {
    return "AT_ICON_WIDGET";
  }
}

export interface AtIconWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TIcon;
